<template>
	<b-card id="ProductosPresentacionRango" no-body>

		<spinner v-if="isLoading"/>

		<!-- DATA TEMPLATE -->
		<template v-else-if="!!value && parseInt(data.count)">
			<b-table :fields="fields" responsive striped class="mb-0" :items="items">
					
				<!-- START TEMPLATES BASICOS DE DATOS -->
				<template #cell(created)="data">{{data.value | humanizar_fecha}} <br> <small>(Última actualizacion {{data.item.modified | humanizar_diferencia}})</small> </template>
				<template #cell(modified)="data">{{data.value | humanizar_diferencia}} <br> <small>(Última actualizacion {{data.item.modified | humanizar_diferencia}})</small> </template>
				<template #cell(costo)="data">{{(data.item.costo / data.item.cantidad) | currency}} </template>
				<template #cell(precio)="data">{{(data.value) | currency}} </template>
				<template #cell(estatus)="data">{{(data.value) | supereasyEstatus}} </template>
				<!-- END TEMPLATES BASICOS DE DATOS -->

				<!-- START OF AVATAR SAMPLES -->
				<template #cell(imagenes_id_agenda)="data">
					<api-img :comp="data.value" :rowed="true" />
				</template>
				<!-- END OF AVATAR SAMPLES -->

				<!-- START OF BOOLEAN SAMPLE -->
				<template #cell(disponible)="data">
					<div class="align-center">
						<!-- <b-button size="sm" variant="primary" v-if="data.value == '1'"> -->
							<i v-if="data.value == '1'" class="fa text-primary fa-check"></i>
						<!-- </b-button> -->
						<!-- <b-button size="sm" v-else> -->
							<i v-else class="fa fa-minus"></i>
						<!-- </b-button> -->
					</div>
				</template>
				<!-- END OF BOOLEAN SAMPLE -->

				<!-- START OF TOOLING -->
				<template #cell(_)="data">
					<b-button @click="checkingItemDetail(data.item)" size="sm" :variant="variant"> <i class="fa fa-fw fa-cog"></i> </b-button>
				</template>
				<!-- END OF TOOLING -->

			</b-table>

			<b-row slot="footer" align-v="center">

				<b-col>
					<strong>Página {{data.page}} de {{Math.ceil(data.count / data.per_page)}}</strong> 
					(Se muestran <strong>{{items.length}} registros</strong> 
					de un total de {{data.count}})
				</b-col>

				<b-col>
					<b-pagination
						class="mt-3"
						v-model="data.page"
						:total-rows="data.count"
						:per-page="data.per_page"
						size="sm"
						align="right"
						prev-text="Anterior"
						next-text="Siguiente"
					/>
				</b-col>
			</b-row>
		</template>
		<!-- DATA TEMPLATE -->

		<!-- EMPTY JUMBOTRON -->
		<b-jumbotron class="mb-0" v-else>
			<template #header>{{labelsCfg.emptyHeader}}</template>
			<template #lead>{{labelsCfg.emptyLead}}</template>
		</b-jumbotron>
		<!-- EMPTY JUMBOTRON -->

	</b-card>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import swal from "sweetalert";
import fkSelect from "@/views/elements/fk-select.vue";
import imgInputAutoload from "@/views/elements/img-input-autoload.vue";
import md5 from "js-md5";

let labelsCfg = {
	emptyHeader: "Resultados no encontrados",
	emptyLead: "Intenta cambiar los rangos o selecciona otra presentación",
	searchPlaceholder: "Buscador...",
	newLabel: "Nuevo",
	btnDelete: "Eliminar",
	btnCancel: "Cancelar",
	btnApply: "Aplicar",
	btnIsProcessing: "Procesando...",
};

let formArchetype = {
	fecha_agenda: null,
	usuarios_vehiculos_id: null,
	sucursales_id: null,
	folio: null,
	tipo_servicio: null,
	estatus: null,
	comentarios: null,
};
export default {
	name: "ProductosPresentacionRango",
	props: {
		route: {
			type: [Object],
			required: false,
		},
		value: {
			type: [Object],
			required: false,
			default: () => {
				return {
					categoria: null,
					presentaciosIdPk: null,
					rangeStart: null,
					rangeEnd: null,
				}
			}
		},
	},
	components: {
		fkSelect,
		imgInputAutoload,
	},
	computed: {
		items() {
			return _.map(this.data.rows, (item) => {
				item._ = " ";
				return item;
			});
		},
		dataMD5() {
			return md5(JSON.stringify(this.form));
		},
		fields(){
			// return null;
			let fields = [
				{
					key: (this.route.params.path == 'entradas') ?  'numero' : 'folio',
					label: (this.route.params.path == 'entradas') ?  'Factura' : 'Pedido',
				}
			]
			fields.push({
				key: 'titulo_extendido',
				label: 'Producto'
			})
			fields.push({
				key: 'fechaEntrega',
				label: 'Fecha de entrega'
			})
			if(this.route.params.path == 'entradas'){
				fields.push({
					key: 'proveedor'
				})
			} else {
				fields.push({
					key: 'cliente'
				})
				fields.push({
					key: 'estatus'
				})
			}
			fields.push({
				key: 'cantidad'
			})
			fields.push({
				key: 'costo'
			})
			if(this.route.params.path == 'salidas'){
				fields.push({
					key: 'precio',
				})
			}
			if(this.route.params.path == 'entradas'){
				fields.push({
					key: '_'
				})
			}
			return fields
		},
		// COMPUTA LA URI
		sourceURI() {
			let path = null,
				indexSource = "paginate/table",
				init

			let value = _.clone(this.value),
				presentacionIdPk = (!!value.presentacionIdPk) ? value.presentacionIdPk : 'not-def';

			if(!!value)
				indexSource = "rangedfilters/productbased"

			switch(this.route.params.path){
				case 'entradas':
					path = 'productos_in_factura_overview'
					break;
				case 'salidas':
					path = 'productos_in_pedidos_overview'
					break;
			}
			
			if(!value){
				init = `${indexSource}/${path}/${this.data.per_page}/${this.data.page}`;
			}else if(!!value){
				if(presentacionIdPk == 'not-def'){
					init = `${indexSource}/${path}/${value.categoria}/cat_id_pk/${value.rangeStart}/${value.rangeEnd}/fechaEntrega/${this.data.per_page}/${this.data.page}`;
				} else {
					init = `${indexSource}/${path}/${presentacionIdPk}/presentacion_id_pk_tipo/${value.rangeStart}/${value.rangeEnd}/fechaEntrega/${this.data.per_page}/${this.data.page}`;
				}
			}
			return init;
		}
	},
	data: () => {
		return {
			isLoading: false,
			isProcessing: false,
			variant: "primary",
			labelsCfg: _.cloneDeep(labelsCfg),
			form: _.cloneDeep(formArchetype),
			data: {
				rows: [],
				count: 0,
				per_page: 25,
				page: 1,
			},
		};
	},
	methods: {
		// PREGUNTA Y CONTINÚA CON EL BORRADO DEL REGISTRO
		tryToDelete(itemID){
			if(!!itemID){
				swal({
					text: '¿Estás seguro que deseas eliminar éste registro?',
					icon: 'info',
					buttons: {
						cancel: 'Cancelar',
						proceed: 'Si'
					}
				}).then(selected => {
					if(selected == 'proceed') {
						// HE SAID YES!
						this.isProcessing = true
						axios.delete(this.dataSource + '/' + itemID).then(response => {
							if(response.status){
								// this.$router.push({name: 'Levantamiento de inventario', params: {id: response.data.id}})
								this.loadUp().then(() => {
									this.$bvModal.hide('main-card-modal')
									this.isProcessing = false
								})
							} else {
								this.isProcessing = false
							}
						})
					}
				})
			} else {
				swal({
					text: 'Para poder eliminar un registro, éste debe especifcar un ID de eliminación.',
				})
			}
		},

		// PREPARA LO QUE TENGAS QUE PREPARAR PARA SUBIR AL SERVIDIOR, COMO AGREGAR VALIDACIONES, DATOS O PROPIEDADES DINÁMICAS, ETC.
		// DEVULEVE FALSO PARA DETENER EL ENVÍO
		getDataForSubmit(){
			let data = _.cloneDeep(this.form);
			data.usuarios_id = this.usuariosId,
			_.forEach(['fecha_agenda', 'usuarios_vehiculos_id', 'sucursales_id', 'tipo_servicio'], keyRequired => {
				if(typeof data == 'object' && !data[keyRequired]){
					swal({
						text: 'Asegúrate de llenar todos los campos con *.',
					})
					data = false;
				}
			})
			return data;
		},
		cleanFormAndOpenModal(){
			this.form = _.cloneDeep(formArchetype)
			this.$bvModal.show('main-card-modal')
		},
		checkingItemDetail(item){
			if(this.route.params.path == 'entradas'){
				this.$router.push({name: 'Factura', params: {id: item.id}})
			}
		},
		async refresh() {
			this.isLoading = true;
			await this.loadUp()
			this.isLoading = false;
		},
		loadUp(){
			return new Promise(success => {
				axios.get(this.sourceURI).then(response => {
					if(typeof response.data.rows != undefined){
						this.data.rows = response.data.rows
						this.data.count = response.data.count
						success()
					}
				})
			})
		},
		hidden(){
			this.form = _.cloneDeep(formArchetype)
		},
		store(){
			let data2send = this.getDataForSubmit()
			if(!!data2send){
				this.isProcessing = true
				axios.post(this.dataSource + ((!!this.form.id) ? '/' + this.form.id : ''), data2send).then(response => {
					if(response.status){
						// this.$router.push({name: 'Levantamiento de inventario', params: {id: response.data.id}})
						this.loadUp().then(() => {
							this.$bvModal.hide('main-card-modal')
							this.isProcessing = false
						})
					} else {
						this.isProcessing = false
					}
				})
			}
		},
		onSubmit($evnt){
			$evnt.preventDefault();
			this.store()
		}
	},
	mounted() {
		this.isLoading = true;
		this.loadUp().then(()=>{
			this.isLoading = false;
		})
	},
	watch: {
		'route.params'(){
			this.refresh()
		},
		'value'(){
			this.refresh()
		},
		'value.categoria'(){
			this.refresh()
		},
		'value.presentacionIdPk'(){
			this.refresh()
		},
		'value.rangeStart'(){
			this.refresh()
		},
		'value.rangeEnd'(){
			this.refresh()
		},
		'data.page'(){
			this.refresh()
		}
	}
};
</script>